<div class="idp-error-indicator flex gap-8 pb-24 items-center justify-center">
  <div
    role="link"
    tabindex="0"
    class="idp-error-indicator-message flex focus:outline focus:outline-2 focus:outline-stroke-04 focus:outline-offset-2 mt-[4px]"
  >
    <img
      class="idp-error-indicator_icon"
      src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert.svg"
    />
    <a
      href="javascript:void(0)"
      role="link"
      tabindex="0"
      aria-live="assertive"
      class="book-widget-global-error-anchor focus:rounded-none focus:bg-[unset] !text-alert text-label-xs-semibold tablet:text-label-sm-semibold focus:outline-stroke-04 focus-visible:outline-offset-2 cursor-pointer hover:underline"
      (click)="handleErrorMessageClick()"
      (keypress)="$event.key === 'Enter' && handleErrorMessageClick()"
    >
      {{ toContinueText }} {{ errorMsg }}
    </a>
  </div>
</div>
